import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import './kioskTheme.css';
import './PaymentResult.css';

function PaymentSuccess() {
    const [params] = useSearchParams();
    const txnid = params.get('txnid');
    const loanId = params.get('loanId');
    const status = params.get('status');

    return (
        <div className="kiosk-theme pay-page pay-page--success">
            <div className="pay-card">
                <div className="pay-icon" aria-hidden="true">✓</div>
                <h1 className="pay-title">Payment successful</h1>
                <p className="pay-subtitle">Your repayment request has been received.</p>
                <dl className="pay-details">
                    <div className="pay-detail">
                        <dt>Loan ID</dt>
                        <dd>{loanId || '--'}</dd>
                    </div>
                    <div className="pay-detail">
                        <dt>Transaction ID</dt>
                        <dd>{txnid || '--'}</dd>
                    </div>
                    <div className="pay-detail">
                        <dt>Status</dt>
                        <dd>{status || 'SUCCESS'}</dd>
                    </div>
                </dl>
                <Link to="/dashboard" className="pay-btn">
                    Back to Dashboard
                </Link>
            </div>
        </div>
    );
}

export default PaymentSuccess;
